<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0" id="movetarget">
            {{ $yuyanbao.shouju }}
          </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav mb-10 pb-8">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              {{ $yuyanbao.shouju }}
            </li>
          </ul>
        </div>
      </nav>
      <div class="page-content mb-10 pb-2" v-loading="loading">
        <div class="container">
          <div class="order-success text-center font-weight-bolder text-dark">
            <i class="fas fa-check"></i>
            {{ $shezhi.shoujubiaoti }}
          </div>

          <ul class="order-view list-style-none">
            <li>
              <label>{{ $yuyanbao.dingdanhao }}</label>
              <strong>{{ dingdan.dingdan }}</strong>
            </li>
            <li>
              <label>{{ $yuyanbao.shibiema }}</label>
              <strong>{{ dingdan.ukey }}</strong>
            </li>
            <li>
              <label>{{ $yuyanbao.zhuangtai }}</label>
              <strong v-if="dingdan.zhuangtai">
                {{ duoyuyan(dingdan.zhuangtai) }}
              </strong>
            </li>
            <li>
              <label>{{ $yuyanbao.riqi }}</label>
              <strong>
                {{ format_date(dingdan.created, 1) }}
              </strong>
            </li>
            <li>
              <label>{{ $yuyanbao.zonge }}</label>
              <strong>
                {{ dingdan.zonge + $shezhi.huobi }}
              </strong>
            </li>
          </ul>

          <div class="order-details-wrapper mb-5">
            <h4 class="title text-uppercase ls-25 mb-5">
              {{ $yuyanbao.xiangqing }}
            </h4>
            <div v-if="dingdan.leixing === 2">
              <table class="order-table mb-8">
                <thead>
                  <tr>
                    <th class="text-dark">
                      <span v-if="dingdan.xiangqing.service">
                        {{ duoyuyan(dingdan.xiangqing.service) }}
                      </span>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align: left">
                      <span
                        v-if="dingdan.xiangqing.service"
                        v-html="duoyuyan(dingdan.xiangqing.service, 'miaoshu')"
                      >
                      </span>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="
                      dingdan.xiangqing.leixing &&
                      JSON.stringify(dingdan.xiangqing.leixing) !== '{}'
                    "
                  >
                    <td style="text-align: left">
                      <span v-if="dingdan.xiangqing.leixing">
                        {{ duoyuyan(dingdan.xiangqing.leixing) }}
                      </span>
                    </td>
                    <td>
                      <img
                        v-if="dingdan.xiangqing.leixing"
                        style="width: 50px; margin-bottom: 10px"
                        :src="dingdan.xiangqing.leixing.tupian || $tupianmoren"
                      />
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in dingdan.xiangqing.wenti"
                    :key="index"
                  >
                    <td style="text-align: left">
                      {{ duoyuyan(item) }}
                    </td>
                    <td>
                      <span v-if="item.jiage > 0">{{
                        (item.jiage / 100).toFixed(2) + $shezhi.huobi
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">{{ $yuyanbao.beizhu }} :</td>
                    <td>
                      {{ dingdan.beizhu }}
                    </td>
                  </tr>
                  <tr v-if="dingdan.fangshi">
                    <td></td>
                    <td>{{ duoyuyan(dingdan.fangshi) }}</td>
                  </tr>
                  <tr v-if="dingdan.fukuan">
                    <td></td>
                    <td>{{ duoyuyan(dingdan.fukuan) }}</td>
                  </tr>
                  <tr v-if="dingdan.zonge !== 0">
                    <td></td>
                    <td>{{ $yuyanbao.zonge + " : " + dingdan.zonge }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="dingdan.leixing === 1">商品</div>
            <table class="order-table mb-8">
              <thead>
                <tr>
                  <th class="text-dark">
                    {{ $yuyanbao.lianxifangshi }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.xing }} {{ dingdan.ming }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.dianhua }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.email }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.dizhi }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.codepostal }}
                    {{ dingdan.chengshi }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table class="order-table mb-8" v-if="dingdan.gongsi">
              <thead>
                <tr>
                  <th class="text-dark">
                    {{ $yuyanbao.gongsi }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align: left">
                    {{ duoyuyan(dingdan.gongsi) }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.gongsi.dianhua }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.gongsi.email }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.gongsi.dizhi }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    {{ dingdan.gongsi.codepostal }}
                    {{ dingdan.gongsi.chengshi }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <span
            class="btn btn-dark btn-rounded btn-icon-left btn-back mt-6"
            @click="$router.push({ name: 'Index' })"
          >
            <i class="w-icon-long-arrow-left"></i>
            {{ $yuyanbao.shouye }}
          </span>
          <span
            class="btn btn-dark btn-outline btn-rounded btn-icon-left btn-back mt-6 ml-6"
            @click="to_pdf"
          >
            <i class="w-icon-fax"></i>
          </span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import { getDingDan } from "@/api/dingdan";

export default {
  name: "Receipt",
  data() {
    return {
      loading: false,
      ukey: "",
      dingdan: {},
    };
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    this.get_dingdan_http();
  },
  methods: {
    get_dingdan_http() {
      this.loading = true;
      getDingDan({ ukey: this.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") this.dingdan = data.data;
        })
        .finally(() => (this.loading = false));
    },
    to_pdf() {
      const doc = new jsPDF();
      doc.text(this.dingdan.dingdan, 10, 10);
      doc.text(this.dingdan.ukey, 10, 20);
      doc.text(this.dingdan.xing, 10, 30);
      doc.text(this.dingdan.ming, 20, 30);
      doc.text(this.duoyuyan(this.dingdan.xiangqing.service), 10, 40);
      doc.text(
        this.duoyuyan(this.dingdan.xiangqing.service, "miaoshu"),
        10,
        50
      );
      window.open(doc.output("bloburl"), "_blank");
    },
  },
};
</script>

<style scoped>
.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
}

.xuanzhuan {
  position: absolute;
  top: 8px;
  left: 0;
  animation: anixuanzhuan 0.8s infinite linear;
}

@keyframes anixuanzhuan {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
